import { apiJson } from './api'
import { createDataClient } from './queryClient'
export const dataClient=createDataClient(
 payload=>apiJson('/data/query',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}),
 (name,args)=>apiJson(`/data/rpc/${encodeURIComponent(name)}`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(args)}),
 true,
)
